import React from 'react';
import styles from './index.module.scss';
import Logo from '@src/components/Logo';
import ShareIcon from '@src/components/ShareIcon';
import { Developer, Discover, Community, JoinUsLinks, Resources } from '@src/constant/navLinks';
import { handleBackTop, scrollToAnchor } from '@src/lib/utils';

const Menu = ({ options, title }) => {
    const handleLinkClick = (e, localLink) => {
        if (localLink) {
            const hash = localLink.split('#')[1];
            const currentHash = window.location.hash.substring(1);
            // If clicking the same hash, scroll to anchor directly
            if (hash && hash === currentHash) {
                e.preventDefault();
                const targetDom = window.document.querySelector(`[name="${hash}"]`);
                if (targetDom) {
                    scrollToAnchor(targetDom, {
                        behavior: 'smooth',
                    });
                    return;
                }
            }
        }
    };
    return <div>
        <div className={styles.headLine}>{title}</div>
        <div className={styles.section}>
            {options.map(({ footerTitle, hasIcon, link, localLink }) => {
                if (localLink) {
                    return <a 
                        key={footerTitle} 
                        className={styles.linkWrpper} 
                        href={localLink}
                        onClick={(e) => handleLinkClick(e, localLink)}
                    >
                        <div className={styles.link}>{footerTitle}</div>
                        {hasIcon && <ShareIcon color="#878787" />}
                    </a>
                }
                return <a target='_blank' href={link} className={styles.linkWrpper} key={footerTitle}>
                    <div className={styles.link}>{footerTitle}</div>
                    {hasIcon && <ShareIcon color="#878787" />}
                </a>
            })}
        </div>
    </div>
};

export default () => {
    return (
      <div className={styles.root}>
        <div className={styles.container}>
          <div className={styles.body}>
            <div className={styles.left}>
              <Logo
                fontColor="white"
                iconColor="#101010"
                onClick={handleBackTop}
              />
              <div className={styles.leftInner}>
                <div className={styles.text}>Join Us</div>
                <div className={styles.icons}>
                  <a target="_blank" href={JoinUsLinks.x}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="24"
                      viewBox="0 0 16 24"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.0979642 4.13656C0.151854 4.21167 1.39988 5.9859 2.87137 8.0793C4.34285 10.1727 5.70383 12.1086 5.89579 12.3814C6.08774 12.6542 6.24478 12.8828 6.24478 12.8895C6.24478 12.8962 6.1733 12.9823 6.08595 13.0808C5.99859 13.1793 5.75253 13.4581 5.53917 13.7004C5.3258 13.9427 4.96611 14.3511 4.73985 14.6079C4.51361 14.8648 4.11558 15.3167 3.85534 15.6123C3.59511 15.9079 3.12714 16.4394 2.8154 16.7933C1.85126 17.888 1.71212 18.0461 0.978182 18.8811C0.586289 19.3269 0.210488 19.7531 0.143086 19.8283C0.0756833 19.9035 0.020531 19.9729 0.020531 19.9825C0.020531 19.9938 0.266687 20 0.714057 20H1.40757L2.17001 19.1322C2.58936 18.6548 3.00303 18.185 3.08927 18.0881C3.27576 17.8786 4.69796 16.2623 4.8175 16.1241C4.86327 16.0711 4.92975 15.9958 4.96524 15.9567C5.00075 15.9175 5.28055 15.6 5.58703 15.2511C5.8935 14.9022 6.15268 14.6082 6.16295 14.5977C6.17323 14.5873 6.33548 14.4029 6.5235 14.1881C6.71153 13.9732 6.87118 13.7974 6.87827 13.7974C6.88538 13.7974 7.85124 15.1632 9.02466 16.8326C10.1981 18.502 11.1791 19.8974 11.2047 19.9335L11.2512 19.9992L13.6301 19.9996C15.5864 19.9999 16.0074 19.9959 15.9999 19.9769C15.992 19.9566 14.8522 18.3329 11.9283 14.1762C9.82332 11.1839 9.54342 10.7817 9.55145 10.7613C9.55925 10.7415 9.84596 10.414 11.7309 8.27167C12.0542 7.90419 12.4999 7.39736 12.7213 7.14537C12.9428 6.89339 13.1663 6.63965 13.2181 6.5815C13.27 6.52335 13.5424 6.2141 13.8236 5.89427C14.1048 5.57445 14.5828 5.03101 14.8859 4.68664C15.1889 4.34227 15.448 4.04691 15.4616 4.03026C15.4849 4.00176 15.4453 4 14.7819 4H14.0775L13.7642 4.35683C13.3472 4.83172 12.5934 5.68809 12.3794 5.93008C12.2848 6.037 12.1668 6.17138 12.1172 6.22869C12.0676 6.28599 11.9697 6.39674 11.8997 6.4748C11.8297 6.55286 11.4768 6.95374 11.1155 7.36564C10.7543 7.77753 10.4538 8.1185 10.4477 8.12335C10.4416 8.12819 10.3642 8.21589 10.2757 8.31825C10.1208 8.49729 9.96312 8.67649 9.24013 9.49542C8.92278 9.85489 8.90651 9.87033 8.87976 9.83729C8.86437 9.81825 7.93435 8.49715 6.81309 6.90152L4.77442 4.00037L2.38721 4.00018L0 4L0.0979642 4.13656ZM1.96115 5.08796C1.97908 5.1147 2.4251 5.73921 2.95232 6.47577C3.95222 7.8727 7.88144 13.3654 10.4084 16.8987C11.2159 18.0278 11.8864 18.9615 11.8984 18.9737C11.9157 18.9911 12.1508 18.9949 12.9971 18.9913L14.0738 18.9868L11.2562 15.0485C9.70657 12.8824 7.46293 9.74626 6.27037 8.0793L4.10205 5.04846L3.01532 5.04391L1.92858 5.03937L1.96115 5.08796Z"
                        fill="#E5E5E5"
                      />
                    </svg>
                  </a>
                  <a target="_blank" href={JoinUsLinks.discord}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.5305 5.06709C23.1055 8.85303 24.3772 13.1235 23.9018 18.0397C23.8998 18.0605 23.889 18.0796 23.8719 18.0921C21.9219 19.524 20.0326 20.3929 18.1699 20.9692C18.1554 20.9736 18.1399 20.9734 18.1255 20.9685C18.1111 20.9637 18.0986 20.9544 18.0898 20.9421C17.6594 20.3434 17.2684 19.7121 16.9259 19.0492C16.9062 19.0101 16.9241 18.9631 16.9646 18.9477C17.5856 18.7137 18.1761 18.4333 18.7442 18.1013C18.7889 18.075 18.7917 18.0109 18.7504 17.9801C18.6299 17.8906 18.5105 17.7966 18.3962 17.7025C18.3748 17.6852 18.346 17.6817 18.3218 17.6934C14.6342 19.3963 10.5946 19.3963 6.86338 17.6934C6.83915 17.6826 6.81037 17.6863 6.78956 17.7034C6.67556 17.7975 6.55586 17.8906 6.43645 17.9801C6.39512 18.0109 6.39854 18.075 6.44357 18.1013C7.01158 18.427 7.6021 18.7137 8.22225 18.9488C8.26244 18.9642 8.28153 19.0101 8.26158 19.0492C7.92642 19.7129 7.53541 20.3442 7.09708 20.943C7.07798 20.9672 7.04663 20.9783 7.01699 20.9692C5.16307 20.3929 3.27381 19.524 1.32384 18.0921C1.3076 18.0796 1.29591 18.0596 1.2942 18.0388C0.896912 13.7864 1.7066 9.48059 4.66233 5.06624C4.66945 5.05455 4.68028 5.04543 4.69282 5.04002C6.14717 4.37255 7.70527 3.88149 9.33375 3.60105C9.36339 3.59649 9.39303 3.61017 9.40842 3.63639C9.60963 3.99264 9.83963 4.4495 9.99524 4.82285C11.7118 4.56065 13.4551 4.56065 15.2076 4.82285C15.3632 4.45748 15.5852 3.99264 15.7856 3.63639C15.7927 3.62339 15.8038 3.61297 15.8172 3.60662C15.8306 3.60027 15.8457 3.59833 15.8602 3.60105C17.4896 3.88235 19.0477 4.3734 20.5009 5.04002C20.5137 5.04543 20.5243 5.05455 20.5305 5.06709ZM10.8679 13.1525C10.8859 11.8954 9.9693 10.8551 8.81876 10.8551C7.67762 10.8551 6.7699 11.8863 6.7699 13.1525C6.7699 14.4185 7.69558 15.4496 8.81876 15.4496C9.96018 15.4496 10.8679 14.4185 10.8679 13.1525ZM18.4438 13.1525C18.4617 11.8954 17.5452 10.8551 16.3949 10.8551C15.2535 10.8551 14.3458 11.8863 14.3458 13.1525C14.3458 14.4185 15.2714 15.4496 16.3949 15.4496C17.5452 15.4496 18.4438 14.4185 18.4438 13.1525Z"
                        fill="#E5E5E5"
                      />
                    </svg>
                  </a>
                  <a target="_blank" href={JoinUsLinks.medium}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.76884 5C10.5072 5 13.5374 8.05143 13.5374 11.8153C13.5374 15.5792 10.5069 18.6303 6.76884 18.6303C3.03073 18.6303 0 15.5792 0 11.8153C0 8.05143 3.0305 5 6.76884 5ZM17.5782 5.39922C19.4474 5.39922 20.9626 8.2715 20.9626 11.8153H20.9628C20.9628 15.3582 19.4476 18.2314 17.5784 18.2314C15.7092 18.2314 14.194 15.3582 14.194 11.8153C14.194 8.27242 15.709 5.39922 17.5782 5.39922ZM22.8097 6.0675C23.4669 6.0675 24 8.64083 24 11.8153C24 14.9888 23.4672 17.5631 22.8097 17.5631C22.1522 17.5631 21.6196 14.9895 21.6196 11.8153C21.6196 8.64106 22.1524 6.0675 22.8097 6.0675Z"
                        fill="#E5E5E5"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className={styles.right}>
              <Menu options={Developer} title="Developer" />
              <Menu options={Discover} title="Discover" />
              <Menu options={Community} title="Community" />
              <Menu options={Resources} title="Resources" />
            </div>
          </div>
          <div className={styles.footer}>
            © {new Date().getFullYear()} Primus Labs. All rights reserved.
          </div>
        </div>
      </div>
    );
};
